import React from "react"
import { PropTypes } from "prop-types"

const Content = (props) => {
	const { StepComponent, saveComponentState, onComponentStateSaved } = props;
	return (
		<div  style={{ padding:'0', marginTop:'-25px' }} col={12}>
			<StepComponent saveComponentState={saveComponentState} onComponentStateSaved={onComponentStateSaved} />
		</div>
	)
};
Content.propTypes = {
	StepComponent: PropTypes.func.isRequired,
	saveComponentState: PropTypes.bool,
	onComponentStateSaved: PropTypes.func,
};
export default Content


// WEBPACK FOOTER //
// ./src/components/common/wizard/components/content.js